<template>
  <div style="padding: 10px 5px;">
    <div class="default-table">
      <ApeTable ref="apeTable"
                :data="dataList"
                :columns="columns"
                :loading="loadingStatus"
                :pagingData="pagingData"
                highlight-current-row
                :summary-method="getSummaries"
                show-summary
                border>
        <el-table-column
                slot="first-column"
                type="selection"
                width="55">
        </el-table-column>
        <el-table-column
                slot="first-column"
                width="60"
                label="序号">
          <template slot-scope="scope">
            <span>{{ offset + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
                slot="second-column"
                prop="order_no"
                label="订单编号"
                header-align="center"
                align="center"
                min-width="160"
                :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <to-order-detail :order="scope.row"/>
          </template>
        </el-table-column>
        <el-table-column
                slot="second-column"
                prop="invoice_money"
                label="申请金额"
                header-align="center"
                align="right"
                min-width="120"
                :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span>{{ gFunc.numberFormat(scope.row.invoice_money, 2) }}</span>
          </template>
        </el-table-column>
        <el-table-column
                slot="second-column"
                prop="customer_name"
                label="客户名称"
                header-align="center"
                align="left"
                min-width="220"
                :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
              <span style="padding: 1px 1px; background-color: #FF5722; color: #fff; font-size: 12px;"
                    v-show="scope.row.order_type === 'strike' || scope.row.order_type === '冲账类型'"
              >冲</span>
            <to-order-detail :order="scope.row" field="customer_name"/>
          </template>
        </el-table-column>
      </ApeTable>

    </div>
  </div>
</template>

<script>
import ApeTable from "@/components/ApeTable";
import {getBillApplyOrder} from "@/api/bill";
import ToOrderDetail from "@/views/adOrder/components/ToDetail";

export default {
  name: "ApplyOrderTable",
  components: {ApeTable, ToOrderDetail},
  props: {
    id: {
      type: Number,
      default() {
        return null
      }
    }
  },
  data() {
    return {
      loadingStatus: false,
      // 分页信息
      pagingData: {
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0,
        page_size: 20,
        // offset: 0
      },
      // 表格列表数据
      dataList: [],
      columns: [
        {
          "title": "品牌",
          "value": "brand",
          "width": 120,
          "header_align": "center",
          "align": "center",
          "sortable": false
        },
        {
          "title": "产品/内容",
          "value": "product",
          "width": 120,
          "header_align": "center",
          "align": "center",
          "sortable": false
        }, {
          "title": "要求发布时间",
          "value": "release_timestamp_alias",
          "width": 120,
          "header_align": "center",
          "align": "center",
          "sortable": true
        }, {
          "title": "红人名称",
          "value": "artist_nickname",
          "width": 120,
          "header_align": "center",
          "align": "center",
          "sortable": false
        }, {
          "title": "经纪人",
          "value": "agent_name",
          "width": 100,
          "header_align": "center",
          "align": "center",
          "sortable": false
        }, {
          "title": "含税收入",
          "value": "payment_account",
          "width": 120,
          "header_align": "center",
          "align": "right",
          "sortable": true
        }, {
          "title": "发票状态",
          "value": "invoice_status_alias",
          "width": 120,
          "header_align": "center",
          "align": "center",
          "sortable": false
        }, {
          "title": "销售",
          "value": "sale_name",
          "width": 100,
          "header_align": "center",
          "align": "center",
          "sortable": false
        }, {
          "title": "执行",
          "value": "executor_name",
          "width": 100,
          "header_align": "center",
          "align": "center",
          "sortable": false
        }, {
          "title": "执行时间",
          "value": "exec_at",
          "width": 120,
          "header_align": "center",
          "align": "center",
          "sortable": true
        }, {
          "title": "回款金额",
          "value": "sum_amount",
          "width": 120,
          "header_align": "center",
          "align": "right",
          "sortable": true
        }, {
          "title": "应收款",
          "value": "remain_account",
          "width": 120,
          "header_align": "center",
          "align": "right",
          "sortable": true
        }, {
          "title": "粉丝福利",
          "value": "weal_price",
          "width": 120,
          "header_align": "center",
          "align": "right",
          "sortable": true
        },  {
          "title": "投流费",
          "value": "invest_flow_fee",
          "width": 120,
          "header_align": "center",
          "align": "right",
          "sortable": true
        }, {
          "title": "微任务价",
          "value": "micro_task_price",
          "width": 120,
          "header_align": "center",
          "align": "right",
          "sortable": true
        }, {
          "title": "授权价",
          "value": "authorized_price",
          "width": 120,
          "header_align": "center",
          "align": "right",
          "sortable": true
        }, {
          "title": "购物车收费",
          "value": "cart_charges",
          "width": 120,
          "header_align": "center",
          "align": "right",
          "sortable": true
        }, {
          "title": "返点金额",
          "value": "rebates_amount",
          "width": 120,
          "header_align": "center",
          "align": "right",
          "sortable": true
        }, {
          "title": "返点比例（%）",
          "value": "rebates_rate",
          "width": 120,
          "header_align": "center",
          "align": "right",
          "sortable": true
        },
        {
          "title": "坑位费",
          "value": "cart_commission",
          "width": 120,
          "header_align": "center",
          "align": "right",
          "sortable": true
        },
        {
          "title": "线下结佣",
          "value": "offline_rebate",
          "width": 120,
          "header_align": "center",
          "align": "right",
          "sortable": true
        },{
          "title": "平台",
          "value": "platforms",
          "width": 120,
          "header_align": "center",
          "align": "left",
          "sortable": false
        }, {
          "title": "内容(发布)形式",
          "value": "content_forms",
          "width": 120,
          "header_align": "center",
          "align": "left",
          "sortable": false
        }, {
          "title": "发布链接",
          "value": "publish_link",
          "width": 120,
          "header_align": "center",
          "align": "left",
          "sortable": false
        }, {
          "title": "是否执行",
          "value": "bool_exec_alias",
          "width": 120,
          "header_align": "center",
          "align": "center",
          "sortable": false
        }, {
          "title": "回款状态",
          "value": "pay_status_alias",
          "width": 120,
          "header_align": "center",
          "align": "center",
          "sortable": false
        }, {
          "title": "结款方式",
          "value": "pay_method_alias",
          "width": 120,
          "header_align": "center",
          "align": "center",
          "sortable": false
        }, {
          "title": "结款时间",
          "value": "payed_timestamp_alias",
          "width": 120,
          "header_align": "center",
          "align": "center",
          "sortable": true
        }, {
          "title": "备注",
          "value": "remark",
          "width": 120,
          "header_align": "center",
          "align": "center",
          "sortable": false
        }, {
          "title": "收款形式",
          "value": "payment_method_alias",
          "width": 120,
          "header_align": "center",
          "align": "center",
          "sortable": false
        }, {
          "title": "合同归档",
          "value": "contract_filed_alias",
          "width": 120,
          "header_align": "center",
          "align": "center",
          "sortable": false
        }, {
          "title": "合同编号",
          "value": "contract_no",
          "width": 120,
          "header_align": "center",
          "align": "center",
          "sortable": false
        }, {
          "title": "合同金额",
          "value": "contract_amount",
          "width": 120,
          "header_align": "center",
          "align": "right",
          "sortable": false
        }, {
          "title": "财务备注",
          "value": "f_remark",
          "width": 120,
          "header_align": "center",
          "align": "left",
          "sortable": false
        }, {
          "title": "建单人",
          "value": "creator_name",
          "width": 120,
          "header_align": "center",
          "align": "center",
          "sortable": false
        }, {
          "title": "创建时间",
          "value": "created_at",
          "width": 120,
          "header_align": "center",
          "align": "center",
          "sortable": true
        }, {
          "title": "修改时间",
          "value": "updated_at",
          "width": 120,
          "header_align": "center",
          "align": "center",
          "sortable": true
        }],
      offset: 0

    }
  },
  methods: {
    getSummaries(param) {
      const {columns, data} = param
      const sums = []
      columns.forEach((column, index) => {
        if (index < 1) {
          return
        }
        if (index === 1) {
          sums[index] = '合计:'
          return
        }
        if (['invoice_money', 'sum_amount', 'remain_account', 'payment_account'].indexOf(column.property) > -1) {
          const values = data.map(item => Number(item[column.property]))
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev * 1 + curr * 1
              } else {
                return prev
              }
            }, 0)
            sums[index] += ''
          } else {
            sums[index] = 'N/A'
          }
          // 格式化数据
          switch (column.property) {
            default:
              sums[index] = this.gFunc.numberFormat(sums[index], 2)
              break
          }
        }
      })

      return sums
    },

    goDetail(row) {
      let id = row.id
      const {href} = this.$router.resolve({
        name: 'editAdOrder',
        params: {id: id},
      });
      window.open(href, "_blank");
    },
    async getList() {
      this.dataList = []
      await getBillApplyOrder({id: this.id}).then((res) => {
        if (res.success) {
          this.dataList = res.model.list ? res.model.list : [];
        }
      })

    }
  },
  created() {
    this.getList()
  }
}
</script>

<style scoped>

</style>
